import request from "@/api";

export function listBrand(data) {
    return request({
        url: '/api/brand/getBrandList',
        method: 'get',
        params: data
    })
}

export function listBrandCache(data) {
    return request({
        url: '/api/brand/getBrandCacheList',
        method: 'get',
        params: data
    })
}

export function saveBrand(data) {
    return request({
        url: '/api/brand/saveBrand',
        method: 'post',
        data: data
    })
}

export function deleteBrand(data) {
    return request({
        url: '/api/brand/deleteBrand',
        method: 'post',
        data: data
    })
}

export function exportBrand(data) {
    return request({
        url: '/api/brand/export',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}